import Vue from "vue";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from '@/langs';
import 'amfe-flexible'
import "@/assets/css/index.css";
import { isMobile } from "@/utils"

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (isMobile()) {
  document.querySelector('html').removeAttribute('class')
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
   
  }
}).$mount("#app");

